import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { UserStats } from '../../types';
import { GroupId } from '../../config/systemConfig';
import { Menu } from 'lucide-react';
interface AppShellRedesignedProps {
  children: React.ReactNode;
  stats: UserStats;
  currentView: string;
  onNavigate: (view: string) => void;
  selectedGroup: GroupId;
  onSelectGroup: (group: GroupId) => void;
}
export function AppShellRedesigned({
  children,
  stats,
  currentView,
  onNavigate,
  selectedGroup,
  onSelectGroup
}: AppShellRedesignedProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  // Track if this is the first render to skip the entry animation
  const isFirstRender = useRef(true);
  const skipInitial = isFirstRender.current;
  if (isFirstRender.current) {
    isFirstRender.current = false;
  }
  return <div className="min-h-screen bg-slate-50 flex" data-id="element-975">
      {/* Desktop Sidebar */}
      <Sidebar currentView={currentView} onNavigate={onNavigate} stats={stats} isCollapsed={isSidebarCollapsed} onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} selectedGroup={selectedGroup} onSelectGroup={onSelectGroup} data-id="element-976" />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden" data-id="element-977">
        {/* Mobile Header */}
        <header className="md:hidden h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 sticky top-0 z-30" data-id="element-978">
          <div className="flex items-center gap-3" data-id="element-979">
            <button onClick={() => setIsMobileNavOpen(true)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" data-id="element-980">
              <Menu className="w-6 h-6" data-id="element-981" />
            </button>
            <span className="font-bold text-slate-900 text-lg" data-id="element-982">
              Cito Meester
            </span>
          </div>

          <div className="flex items-center gap-3" data-id="element-983">
            <div className="px-2 py-1 bg-indigo-50 rounded-lg text-xs font-bold text-indigo-700" data-id="element-984">
              Groep {selectedGroup}
            </div>
            <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-700 font-bold text-sm border-2 border-white shadow-sm" data-id="element-985">
              {stats.name.charAt(0)}
            </div>
          </div>
        </header>

        {/* Scrollable Content */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 md:p-8" data-id="element-986">
          <div className="max-w-6xl mx-auto w-full" data-id="element-987">
            <AnimatePresence mode="wait" data-id="element-988">
              <motion.div key={currentView} initial={skipInitial ? false : {
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -10
            }} transition={{
              duration: 0.3
            }} className="w-full" data-id="element-989">
                {children}
              </motion.div>
            </AnimatePresence>
          </div>
        </main>
      </div>

      {/* Mobile Navigation Drawer */}
      <MobileNav isOpen={isMobileNavOpen} onClose={() => setIsMobileNavOpen(false)} currentView={currentView} onNavigate={onNavigate} stats={stats} selectedGroup={selectedGroup} onSelectGroup={onSelectGroup} data-id="element-990" />
    </div>;
}